import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const CoursesQuery = graphql.persisted(
  "CoursesQuery",
  graphql(`
    query CoursesQuery($schoolYearId: ID!) {
      schoolYear(id: $schoolYearId) {
        id
        courses {
          id
          name
          slug
          subtitle
          catalogCode
          gradeLevelKeys
          description
          defaultSections
          terms {
            id
            name
            position
          }
          transcriptCourses {
            id
            name
            creditValue
            termCount
            classOfferingIds
            gradingTemplate {
              id
              name
              description
              categories { id name weight dropLowest position }
            }
            gradingTemplateOutOfDate
            categories {
              id
              name
              weight
              dropLowest
              position
              locked
              lockedByGradebookNames
            }
          }
          classOfferings {
            id
            section
            displayName
            slug
            capacity
            activeStudentCount
            term {
              id
              name
              position
            }
            instructors {
              id
              role
              person {
                id
                firstName
                lastName
              }
            }
          }
        }
        terms {
          id
          name
          position
        }
        school {
          id
          gradeLevelsSetting {
            items {
              description
              order
            }
          }
          staffMembers {
            id
            kind
            person {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  `)
);

export { CoursesQuery };

export function useCoursesQuery(schoolYearId?: string) {
  return useQuery(CoursesQuery, {
    variables: { schoolYearId: schoolYearId! },
    skip: !schoolYearId,
  });
}
